module.exports = __webpack_public_path__ + "static/media/green-check-icon.589f2dab.svg";